var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { DialogContent, DialogOverlay } from '@reach/dialog';
const variants = {
    default: {
        marginY: [4, null, '10vh'],
        width: [null, null, '90vw'],
        minHeight: '100vh',
    },
    dialog: {
        maxWidth: 600,
        marginY: [4],
        backgroundColor: 'white',
    },
    largeDialog: {
        marginX: [0, 'auto'],
        width: ['100vw', null, '80vw'],
        marginTop: [0, '10vh'],
        maxHeight: ['100vh', '80vh'],
        backgroundColor: 'white',
        overflow: 'scroll',
    },
    largest: {
        marginY: [4, null, 0],
        width: [null, '100vw', '90vw'],
    },
    fullScreen: {
        marginY: [4, null, 0],
        width: [null, '100vw', '100vw'],
    },
};
/**
 * Creates a modal dialog.
 * @param {object} props The props,
 * @param {string} props.id
 * @param {() => void} props.onClose
 * @param {React.ReactNode} props.children
 * @param {keyof typeof variants} [props.variant]
 * @param {boolean} [props.isOpen]
 */
export default function Modal(_a) {
    var { id, onClose, children, variant, isOpen = true } = _a, rest = __rest(_a, ["id", "onClose", "children", "variant", "isOpen"]);
    return (_jsx(DialogOverlay, Object.assign({ sx: {
            zIndex: 'modal',
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            overflow: 'auto',
            backgroundColor: 'rgba(0, 0, 0, 0.33)',
        }, onDismiss: onClose, isOpen: isOpen }, { children: _jsx(DialogContent, Object.assign({}, rest, { sx: Object.assign({ marginX: [4, null, 'auto'], padding: 0, outline: 'none', position: 'relative' }, (variants[variant] || variants.default)) }, { children: children })) }), id));
}
//# sourceMappingURL=Modal.js.map